import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UPDATE_POST_CATEGORY } from '@/modules/API/news/news.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../newsSettings.module.scss'
import { PostCategory } from '@/types/NewsFeed.ts'

interface UpdatePostCategoryDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
    category: PostCategory
}

const UpdatePostCategoryDialog: FunctionComponent<UpdatePostCategoryDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId,
    category
}: UpdatePostCategoryDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [value, setValue] = useState<string>(category.name)

    useEffect(() => {
        setValue(category.name)
    }, [category])

    const [updatePostCategory] = useMutation(UPDATE_POST_CATEGORY, {
        variables: { daycareId, postCategoryId: category.id, name: value },
        onCompleted: () => {
            refetch()
            handleClose()
            showNotificationSuccess(t('postCategoryUpdated'))
        },
        onError: () => {
            handleClose()
            showNotificationError(t('postCategoryUpdatedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('updatePostCategory')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={value}
                    setValue={setValue}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 1, max: 256 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='confirm'
                        disabled={value.length < 1 || value.length > 256 || value === category.name}
                        onClick={() => updatePostCategory()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default UpdatePostCategoryDialog
